/* eslint-disable array-callback-return */
import React, { useMemo } from "react";
import { RouteProps } from "react-router";
import styled from "styled-components";
import { HomeHero } from "../components/pages/home/HomeHero";
import { HomeText } from "../components/pages/home/HomeText";
import { HomeProducts } from "../components/pages/home/products/HomeProducts";
import { HomePromo } from "../components/pages/home/promos/HomePromo";
import { HomePromos } from "../components/pages/home/promos/HomePromos";
import useHome, { HomeContentType } from "../hooks/api/queries/useHome";

const HomeSection = React.memo(({ item }: { item: any }) => {
  switch (item.contentType) {
    case HomeContentType.HOME_HERO:
      return <HomeHero item={item} />;
    case HomeContentType.HOME_PRODUCTS_PUSH:
      return <HomeProducts item={item} />;
    case HomeContentType.HOME_PROMO_PUSH:
      return <HomePromo item={item} />;
    case HomeContentType.HOME_TEXT:
      return <HomeText item={item} />;
    case HomeContentType.HOME_FOOTER_PROMO_PUSH:
      return <HomePromos item={item} />;
    default:
      return null;
  }
});

export const Home: React.FC<RouteProps> = () => {
  const { data } = useHome();

  const sortedData = useMemo(
    () => data?.slice().sort((a, b) => a.sorting - b.sorting),
    [data],
  );

  if (!sortedData) return null;

  return (
    <Container>
      {sortedData.map((item) => (
        <HomeSection key={`home-${item.id}`} item={item} />
      ))}
    </Container>
  );
};

const Container = styled.div`
  min-height: 101vh;
`;
